import { Component, ViewChild,  ElementRef} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { DatePipe } from '@angular/common';
import {AccountService} from "../../../account/account.service";
import {DepositPixService} from "../depositPix.service";
import {DepositPixModel} from "../depositPix.model";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from "../../../../shared/services/auth.service";
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-depositPix',
  templateUrl: './depositPix.component.html',
  styleUrls: ['./depositPix.component.scss'],
  providers: [ DatePipe]
})
export class DepositPixComponent {
  depositoPix = new FormGroup({
    idTransacao: new FormControl<string>('',[Validators.required]),
  });

  public nomeRecebedor: string;
  public documentoRecebedor: string;
  public valor: string;
  public data: string;
  public isSubmitted: boolean;
  public openConfirm: boolean;
  public validationCode: string;
  public errorMessage: string;
  public isLoaded: boolean;
  public dictResponse: any;
  public idFeedback: any;
  public chavePixDeposito: string;
  public nomeTitular: string;
  public banco: string;
  public totpCode: string = '';

  

  @ViewChild('requestTOTPCode') validateToken: ElementRef | any;

  constructor(private accountService : AccountService,
              private modalService: NgbModal,
              private depositPixService : DepositPixService,
              private authService: AuthService,
              private toastr: ToastrService,
              private datePipe: DatePipe) {
    this.nomeRecebedor = '';
    this.documentoRecebedor= '';
    this.valor = ''
    this.data = ''
    this.isSubmitted = false;
    this.isLoaded = true;
    this.errorMessage = '';
    this.validationCode = '';
    this.openConfirm = false;
    this.dictResponse = '';
    this.idFeedback = '';
    this.chavePixDeposito = '';
    this.nomeTitular = '';
    this.banco = '';
  }

  ngOnInit() {
    this.getAccountValues();
  }

  public clearForm() {
    this.depositoPix.reset();
    this.accountService.getAccount().then((value) => {
      this.isSubmitted = false;
      this.openConfirm = false;
    });
  }

  copyPixKey(): void { 
    if (!this.chavePixDeposito) {
      this.toastr.warning('Não há chave Pix para copiar', 'Aviso', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
      return;
    }
    navigator.clipboard.writeText(this.chavePixDeposito).then(() => {
      this.toastr.success('Chave Pix copiada com sucesso!', 'Sucesso', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    }).catch(err => {
      this.toastr.error('Erro ao copiar Chave Pix', 'Erro', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    });
  }

  async pasteTotpCode(): Promise<void> {
    try {
      this.validationCode = (await navigator.clipboard.readText()).trim();
    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  async paste(): Promise<void> {
    try {
      const text = await navigator.clipboard.readText();

      this.depositoPix.controls.idTransacao.setValue(text.trim());

    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  getAccountValues(){
    this.accountService.getAccount().then(
      value => {
        this.chavePixDeposito = value.pixKeyDepositDict;
        this.nomeTitular = value.nameDepositDict;
        this.banco = value.nameBankDepositDict;
      }
    );
  }

  openDataConfirm() {
    this.isSubmitted = true;
    this.isLoaded = false;
    if (!this.formIsValid()) {
      this.isLoaded = true;
      return;
    }
    this.depositPixService
      .searchDeposit(this.depositoPix.controls.idTransacao.value!.trim().replace(/\s+/g, ''))
      .then((value) => {
        this.dictResponse = value;
        this.nomeRecebedor = this.dictResponse.name;
        this.documentoRecebedor = this.dictResponse.document;
        this.valor = this.dictResponse.amount;
        this.data = this.datePipe.transform(this.dictResponse.data, 'dd/MM/yyyy HH:mm') || '';
        this.isLoaded = true;

        if (this.dictResponse.isValidated) {
          this.makeDeposit();
        } else {
          this.openConfirm = true;
        }
      })
      .catch((error) => {
        this.toastr.error(error.error.mensagem, 'Erro', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        this.isLoaded = true;
      });
  }


  makeDeposit() {
    if(this.authService.isReadOnly()){
      this.toastr.error('Seu usuário não tem permissão para realizar essa operação!','Erro',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    this.modalService.open(this.validateToken, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'sm',
    });
  }

  public formIsValid() : boolean{
    if(this.depositoPix.controls.idTransacao.invalid){
      this.idFeedback = 'Id obrigatório!!'
    }
    return this.depositoPix.valid;
  }

  async validateTotp() {
      if (await this.isValidTotp()) {
        this.modalService.dismissAll();
        let depositPixModel = new DepositPixModel();
        depositPixModel.endToEndId = this.depositoPix.controls.idTransacao.value!.trim().replace(/\s+/g, '');
        firstValueFrom(this.depositPixService.sendDeposit(depositPixModel))
          .then((value) => {
            if(value.success)
            {
              console.log(value)
              this.toastr.success(value.message,'Sucesso',
                {
                  timeOut: 3000,
                  positionClass: 'toast-center-center',
                }
              );
            }
            else
            {
              console.log(value)
              this.toastr.warning(
                `Algo deu errado, verificar com o suporte`,
                'Alerta',
                {
                  timeOut: 3000,
                  positionClass: 'toast-center-center',
                }
              );
            }
  
            this.clearForm();
            this.isLoaded = true;
          })
          .catch((error) => {
            this.toastr.error(error.error.mensagem, 'Erro', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            this.isLoaded = true;
          });
      } else {
        this.errorMessage = 'Código de autenticação inválido!';
      }
    }

    async isValidTotp() {
      let isValid: boolean = false;
      await this.authService
        .validateTotpCode(this.validationCode)
        .then((value) => {
          isValid = value.isValid;
        });
      return isValid;
    }
}

